import { Link } from "react-router-dom";
import type { Story } from "@/mocks/stories";

interface StoryCardProps {
  story: Story;
  variant?: "default" | "wide";
}

export default function StoryCard({ story, variant = "default" }: StoryCardProps) {
  const isWide = variant === "wide";

  return (
    <article
      className={`group flex ${
        isWide ? "flex-col md:flex-row" : "flex-col"
      } bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors`}
    >
      <Link
        to={`/stories/${story.id}`}
        className={`block overflow-hidden bg-background-200 ${
          isWide ? "md:w-2/5 shrink-0 h-52 md:h-auto" : "w-full h-52"
        }`}
        aria-label={story.title}
      >
        <img
          src={story.image}
          alt={`${story.title}主题配图`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700"
        />
      </Link>

      <div className={`p-5 md:p-6 flex flex-col ${isWide ? "md:flex-1" : "flex-1"}`}>
        <div className="flex flex-wrap items-center gap-2">
          <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-secondary-100 text-secondary-900 whitespace-nowrap">
            {story.category}
          </span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">{story.date}</span>
          <span className="text-xs text-foreground-500 whitespace-nowrap">· {story.readTime}</span>
        </div>

        <h3 className="mt-3 font-heading text-lg md:text-xl font-bold text-foreground-950 leading-snug">
          <Link to={`/stories/${story.id}`} className="hover:text-primary-600 transition-colors cursor-pointer">
            {story.title}
          </Link>
        </h3>

        <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3">{story.excerpt}</p>

        <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground-800 truncate">{story.author}</p>
            <p className="text-xs text-foreground-500 truncate">{story.role}</p>
          </div>
          <Link
            to={`/stories/${story.id}`}
            className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            阅读亲述
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}